import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import RouteBloc from "../../../bloc/route_bloc";
import App_header from "../../component/app_header/app_header";
import Config from "../../../Config";
import AppLoadingDialog from "../../dialog/app_loading_dialog";
import "./quotation_screen.css";
import { setFilterBy } from "../../../data/redux/reducers/filterReducer";
import BaseScreen from "../base/base_screen/base_screen";
import App_header_title_simple from "../../component/app_header_title/app_header_title_simple";
import App_daterange_filter from "../../component/app_filters/app_daterange_filter";
import App_dropdown_filter from "../../component/app_filters/app_dropdown_filter";
import { ReactComponent as LeftArrowIcon } from "../../../Arrow_Left.svg";
import { ReactComponent as RightArrowIcon } from "../../../Arrow_Right.svg";
import { Pagination } from "antd";
import GeneralBloc from "../../../bloc/general_bloc";
import AppQuotationCard from "../../component/app_quotation_card/app_quotation_card";
import AppModal from "../../component/app_modal/app_modal";
import UserAccessBloc from "../../../bloc/user_access_bloc";
import QuotationBloc from "../../../bloc/quotation_bloc";
import moment from "moment";
import AppSearchFilter2 from "../../component/app_filters/app_search_filter2";
import AppBottomBar from "../../component/app_bottom_bar/app_bottom_bar";
import UtilBloc from "../../../bloc/util_bloc";
import ProposalBloc from "../../../bloc/mrtt_proposal_bloc";

class QuotationSelectionScreen extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            loading: false,
            route: routeParams,
            client: Config.context,
            userData: null,
            placeholderOverview: this.props.dateFilterGlobal?.overallDateValue
                ? this.props.dateFilterGlobal.overallDateValue
                : "",
            fromDate: '2000-01-01',
            toDate: new Date(),
            sortingCriteria: 'cms_createdOn',
            filterCriteriaSetting: '',
            sortingCriteriaOptions: {
                captions: ['Creation Date', 'Last Updated'],
                values: ['cms_createdOn', 'cms_updatedOn'],
                default: 'Creation Date',
                defaultPlaceholder: 'Creation Date'
            },
            sortOrder: 'DESC',
            displayType: 'grid',
            sortOptions: [
                {
                    captions: 'Recent - Oldest',
                    values: 'DESC',
                },
                {
                    captions: 'Oldest - Recent',
                    values: 'ASC'
                },
            ],
            selectedStatus: 'PENDING',
            keyword: '',
            quotationList: '',
            quotationAllCount: null,
            quotationDraftCount: null,
            quotationGeneratedCount: null,
            quotationPendingCount: null,
            initiatedStatus: false,
            currentPage: 1,
            totalPage: 0,
            limitItem: 0,
            selectedQuotationId: null,
            isDeleteModalOpen: false,
            isModalOpen: false,
            privacyPolicyStep: 1,
            isPrivacyPolicyScrollToEnd: false,
            selectedQuotation: '',
        };
    }


    componentDidMount() {
        this.getDateRangeFilter();
        this.getUserData();
        this.getQuotationCount();
        this.getQuotationList();
    }

    async getUserData() {
        let userData = await UserAccessBloc.getUserData();
        this.setState({ userData: userData });
    }

    async getQuotationList() {
        let userData = await UserAccessBloc.getUserData();
        let listArr = [];
        let quotationDataList = await QuotationBloc.getListingData(
            userData.username,
            // 'SHA002',
            'quotation',
            this.state.sortingCriteria,
            this.state.sortOrder,
            moment(this.state.fromDate).format('YYYY-MM-DD HH:SS:MM'),
            moment(this.state.toDate).format('YYYY-MM-DD 23:59:59'),
            this.state.selectedStatus,
            this.state.currentPage - 1 || 0,
            this.state.keyword || ''
        )
        if (quotationDataList) {
            quotationDataList.data.map((item) => {
                listArr.push(item.quotation);
            })
            this.setState({
                quotationList: listArr,
                totalPage: quotationDataList.page.pageCount,
                totalItem: quotationDataList.page.total,
                limitItem: quotationDataList.page.limit
            })
        }
    }

    async getQuotationCount() {
        let userData = await UserAccessBloc.getUserData();
        let dataListingCount = await QuotationBloc.getListingCountData(
            userData.username,
            // 'SHA002',
            'quotation',
            this.state.dateFilter,
            moment(this.state.fromDate).format('YYYY-MM-DD HH:SS:MM'),
            moment(this.state.toDate).format('YYYY-MM-DD 23:59:59'),

        );

        if (dataListingCount) {
            this.setState({
                quotationAllCount: dataListingCount.data.all,
                quotationDraftCount: dataListingCount.data.draft,
                quotationGeneratedCount: dataListingCount.data.generated,
                quotationPendingCount: dataListingCount.data.pending,
            })
        }
    }

    async handleEditQuotation(id) {
        let userData = UserAccessBloc.getUserData();

        let response = await QuotationBloc.editGeneratedQuotation(id);
        if (response) {
            window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_personal_details}/${id}`
        } else {
            this.setState({
                isError: true,
                errorMessage: 'This quotation cannot be edit.'
            })
        }
    }

    async handleDeleteQuotation(id) {
        let userData = UserAccessBloc.getUserData();
        let response = await QuotationBloc.deleteQuotationById(id);
        if (response.success) {
            this.setState({
                isDeleteModalOpen: false
            })
            this.getQuotationList()
        } else {
            this.setState({
                isError: true,
                errorMessage: 'Quotation delete failed.'
            })
        }
    }

    init() {
        // this.setState({ loading: true });
        // this.getQuotationCount();
        // this.getQuotationList();
        this.setState({ loadoing: false });
    }

    getFilterStatus() {
        return this.props.match.params.status;
    }

    getDateRangeFilter = () => {
        let dateRangeOverallSetting = {
            captions: ['All Time', 'Last 30 Days', 'Last 60 Days', 'Custom'],
            codes: ['All', '30', '60', 'range'],
            default: 'All',
            defaultPlaceholder: 'All Time'
        }

        this.setState({
            dateRangeOverall: dateRangeOverallSetting,
            dateFilter:
                dateRangeOverallSetting.codes[0] ||
                dateRangeOverallSetting.default,
            placeholderOverview:
                dateRangeOverallSetting.captions[0] ||
                dateRangeOverallSetting.defaultPlaceholder,
        });
    }

    handleFilterDate = (dateValue) => {
        let today = moment();
        let fromDate = '';
        let toDate = '';
        if (dateValue == 'All') {
            fromDate = '2000-01-01'
            toDate = today.format('YYYY-MM-DD')
        } else if (dateValue != "range") {
            fromDate = today.subtract(dateValue, 'day').format('YYYY-MM-DD')
            toDate = moment().format('YYYY-MM-DD')
        }
        this.setState({
            dateFilter: dateValue,
            fromDate: fromDate,
            toDate: toDate
        }, () => {
            this.getQuotationList();
            this.getQuotationCount();
        });
    }

    handleDateRange = (dateRange) => {
        let fromDate = dateRange ? dateRange[0] : null;
        let toDate = dateRange ? dateRange[1] : null;

        this.setState(
            {
                ...this.state,
                fromDate: fromDate,
                toDate: toDate,
            }, () => {
                this.getQuotationList();
                this.getQuotationCount();
            }
        );
    }

    handleFilterListByStatus = (status) => {
        let currentStatus = this.state.selectedStatus == status ? 'ALL' : status;

        this.setState({ selectedStatus: currentStatus }, () => {
            this.getQuotationList();
        });

    }

    handleSortingCriteriaChange = (sort) => {
        this.setState({ sortingCriteria: sort }, () => {
            this.getQuotationList();
        });
    }

    handleSortOrderChange = (order) => {
        this.setState({ sortOrder: order }, () => {
            this.getQuotationList();
        })
    }

    handleOnClickSearch = () => {
        console.log("searching")
    }

    handleChangeKeyword = (keyword) => {
        this.setState({ keyword: keyword }, () => {
            this.getQuotationList();
        })
    }

    handlePageChange = (page) => {
        this.setState({ currentPage: page }, () => {
            this.getQuotationList();
        });
    }

    async getSelectedBank() {
        let entity = this.props?.userGlobal?.roles[0]?.entity || await JSON.parse(localStorage.getItem("selectedBank"))?.id;
        return entity;
    }

    async handleProceedToProposal() {
        this.setState({ loading: true });
        let generateQuotation = await QuotationBloc.generateQuotation(this.state.selectedQuotation);
        if (generateQuotation.success) {
            let result = await ProposalBloc.createNewProposal({ id: this.state.selectedQuotation, sourceChannel: await this.getSelectedBank() });
            if (result.success) {
                window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_provide_details}/${result.data[0].proposal.id}`
            } else {
                this.setState({
                    title: 'Error',
                    isError: true,
                    errorMessage: result?.message || 'Failed to generate Quotation'
                })
            }
        } else {
            this.setState({
                title: 'Error',
                isError: true,
                errorMessage: 'Failed to generate Quotation'
            })
        }
        this.setState({ loading: false });
    }

    loadingContent() {
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <AppLoadingDialog isLoading={this.state.loading} />
            </div>
        );
    }

    getQuotationStatus = (status) => {
        let quotationStatus = ''
        status === 'Proposal Proceeded' ? quotationStatus = 'GENERATED' :
            status === 'Quotation Created' ? quotationStatus = 'PENDING' :
                status === 'Draft' ? quotationStatus = 'DRAFT' :
                    quotationStatus = status;

        return quotationStatus;
    }

    renderToolBar = () => {
        return (
            <div className="d-flex">
                <div style={{}}>
                    <App_dropdown_filter
                        onSelectedDateFilter={this.handleFilterDate}
                        dataDateByCaption={this.state.dateRangeOverall?.captions || []}
                        dataDateByValue={this.state.dateRangeOverall?.codes || []}
                        placeholder={this.state.placeholderOverview}
                    />
                </div>
                <div style={{}}>
                    <App_daterange_filter
                        isNotRange={this.state.dateFilter != "range"}
                        defaultValueFromDate={this.state.fromDate}
                        defaultValueToDate={this.state.toDate}
                        value={[this.state.fromDate, this.state.toDate]}
                        disabled={this.state.dateFilter == "range" ? false : true}
                        onSelectedDateRange={this.handleDateRange}
                    />
                </div>

                <div className="ml-2 row" style={{ width: '100%' }}>
                    <AppSearchFilter2
                        title={"Search by reference number/client name..."}
                        onChangeKeyword={this.handleChangeKeyword}
                        onClickSearch={this.handleOnClickSearch}
                    />
                </div>

            </div>
        )
    }

    renderGridList = () => {
        return (
            <>
                <div className="row px-2" style={{ rowGap: '1%', columnGap: '1%' }}>
                    {
                        this.state.quotationList && this.state.quotationList.map((data) => {
                            return (
                                <AppQuotationCard
                                    name={data.fullName}
                                    id={data.id}
                                    status={data.trxStatus}
                                    refNo={data.refNo}
                                    idNo={data.idNo}
                                    createdDate={moment(data.cms_createdOn).format('DD/MM/YYYY')}
                                    lastUpdated={moment(data.cms_updatedOn).format('DD/MM/YYYY')}
                                    handleDelete={(id) => this.handleDeleteQuotation(id)}
                                    handleEdit={(id) => this.handleEditQuotation(id)}
                                    props={this.props}
                                    selected={this.state.selectedQuotation == data.id}
                                    selection={true}
                                    handleSelection={() => this.setState({ selectedQuotation: data.id })}
                                    module={'quotation'}
                                />
                            )
                        })
                    }
                </div>
                <div
                    style={{ padding: 16 }}
                    className="align-items-center d-flex  w-100"
                >
                    {/* {this.props.data.length ? ( */}
                    <>
                        <div style={{ width: "40%" }}>
                            {this.state.currentPage} -{" "}
                            {this.state.limitItem} of{" "}
                            {this.state.totalItem} items
                        </div>
                        <div className="d-flex align-items-center">
                            <div className="page_title_paggination">Page</div>
                            <Pagination
                                current={this.state.currentPage || 1}
                                total={this.state.totalItem}
                                onChange={(e) => this.handlePageChange(e)}
                                style={{ bottom: "0px", width: "100%" }}
                                nextIcon={<RightArrowIcon />}
                                prevIcon={<LeftArrowIcon />}
                                pageSize={12}
                                pageSizeOptions={[10]}
                                showLessItems
                                size="default"
                            />
                            <div
                                className="page_total_paggination"
                            >
                                of  {this.state.totalPage}
                            </div>
                        </div>
                        <div></div>
                    </>
                    {/* ) : null} */}
                </div>
            </>
        )
    }

    renderBottomBar = () => {
        return (
            <AppBottomBar
                enable={!UtilBloc.isNullOrEmpty(this.state.selectedQuotation)}
                lableNext={'Proceed to Proposal'}
                alignContent={"right"}
                buttonWidth={"auto"}
                onNext={(e) => { this.handleProceedToProposal() }}
            />
        )
    }

    render() {
        return (
            <>
                <div style={{ fontFamily: 'Lato' }}>
                    {this.state.loading && this.loadingContent()}
                    {/* <BaseScreen
                        listener={(userSettings) => {
                            this.init();
                        }}
                    > */}
                    <App_header
                        data={this.state.userData}
                        route={this.state.route.entity}
                    />
                    <div
                        style={{
                            marginTop: 110,
                            paddingLeft: 42,
                            paddingRight: 42,
                            paddingBottom: 150,
                        }}
                    >
                        <div className="">
                            <App_header_title_simple
                                title="Selection Quotation"
                                description="Select a quotation to create new proposal"
                            />
                        </div>
                        <div className="mt-4">
                            {this.renderToolBar()}
                        </div>
                        <div className="my-3">
                            Showing <b className="px-1">{this.state.totalItem}</b> result
                        </div>
                        {this.state.displayType === 'list' && this.renderTableList()}
                        {this.state.displayType === 'grid' && this.renderGridList()}
                    </div>

                    {this.renderBottomBar()}
                    {/* </BaseScreen> */}
                </div >
                <AppModal
                    open={this.state.isError}
                    title={this.state.title}
                    subtitle={this.state.errorMessage}
                    closable={false}
                    positiveButtonText={'OK'}
                    handleModalClose={() => { this.setState({ isError: false }) }}
                    handlePositivePress={() => this.setState({ isError: false })}
                />

                <AppModal
                    open={this.state.isDeleteModalOpen}
                    handleModalClose={this.handleDeleteModalClose}
                    width={'50%'}
                    title={'Do you want to delete this quotation ?'}
                    negativeButtonText={'Cancel'}
                    positiveButtonText={'Yes, Delete'}
                    handleNegativePress={this.handleDeleteModalClose}
                    handlePositivePress={() => this.handleDeleteQuotation(this.state.selectedQuotationId)}
                >
                    <span style={{ fontSize: 16, color: '#808EA8' }}>If you delete this quotation, you wil loose any progress you’ve made.</span>
                </AppModal>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
});

const mapDispatchToProps = { setFilterBy };

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(QuotationSelectionScreen)
);